import { render, staticRenderFns } from "./SessionsManage.vue?vue&type=template&id=52d559aa&"
import script from "./SessionsManage.vue?vue&type=script&lang=js&"
export * from "./SessionsManage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/sessions.css?vue&type=style&index=0&lang=css&"
import style1 from "./SessionsManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports